// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"d1478cdc","621":"49133d8e"}[chunkId] + ".chunk.css";
};